import { defineMessages } from 'react-intl';

export default defineMessages({
  clarification_subtitle: {
    id: 'app.productConfig.ProductConfiguration.clarification.subtitle',
    defaultMessage: '¿Querés aclarar algo?',
  },
  clarification_input_label: {
    id: 'app.productConfig.ProductConfiguration.clarification.input_label',
    defaultMessage: 'Notas al producto',
  },
  clarification_subtitle_restaurant_coffee: {
    id:
      'app.productConfig.ProductConfiguration.clarification._subtitle_restaurant_coffee',
    defaultMessage: 'Notas para este producto',
  },
  clarification_restaurant_description: {
    id:
      'app.productConfig.ProductConfiguration.clarification.restaurant_description',
    defaultMessage: 'El local intentará seguirlas cuando lo prepare.',
  },
  clarification_coffee_description: {
    id:
      'app.productConfig.ProductConfiguration.clarification.coffee_description',
    defaultMessage: 'El local intentará seguirlas cuando lo prepare.',
  },
  clarification_input_label_restaurant: {
    id:
      'app.productConfig.ProductConfiguration.clarification.input_label_restaurant',
    defaultMessage: 'Escribe las instrucciones que necesites.',
  },
  clarification_input_label_coffee: {
    id:
      'app.productConfig.ProductConfiguration.clarification.input_label_coffee',
    defaultMessage: 'Escribe las instrucciones que necesites.',
  },
  button_action: {
    id: 'app.productConfig.ProductConfiguration.button.action',
    defaultMessage: 'Agregar a mi pedido',
  },
  button_modify_action: {
    id: 'app.productConfig.ProductConfiguration.button.modify_action',
    defaultMessage: 'Modificar mi pedido',
  },
  quantity_subtitle: {
    id: 'app.productConfig.ProductConfiguration.quantity.subtitle',
    defaultMessage: 'Cantidad de unidades',
  },
  product_configuration_age_validation_error: {
    id: 'app.productConfig.ProductConfiguration.ageValidation.error',
    defaultMessage: 'El producto no fué agregado a tu pedido por ser menor.',
  },
  product_configuration_age_validation_subtitle: {
    id: 'app.productConfig.ProductConfiguration.ageValidation.subtitle',
    defaultMessage: 'El producto no fué agregado a tu pedido por ser menor.',
  },
  shop_limit_overcomed: {
    id: 'app.productConfig.ProductConfiguration.shop.limi',
    defaultMessage: 'Has alcanzado el límite de unidades para este local.',
  },
  product_limit_value_overcomed: {
    id: 'app.productConfig.ProductConfiguration.limit.product.overcome',
    defaultMessage: 'Ya alcanzaste el límite de compra de este producto.',
  },
  product_overcoming_limit_value: {
    id: 'app.productConfig.ProductConfiguration.limit.product',
    defaultMessage:
      'Con estas unidades alcanzarías el límite para este producto.',
  },
  product_quantity_text: {
    id:
      'app.productConfig.ProductConfiguration.QuantityCounter.product_quantity_text',
    defaultMessage:
      'Podés agregar hasta {prodQuantity} unidades de este producto.',
  },
  button_action_add: {
    id: 'app.productConfig.ProductConfiguration.button.action.add',
    defaultMessage: 'Agregar a mi pedido',
  },
  button_action_modify: {
    id: 'app.productConfig.ProductConfiguration.button.action.modify',
    defaultMessage: 'Modificar mi pedido',
  },
  button_product_not_available_title: {
    id:
      'app.productConfig.ProductConfiguration.button_product_not_available_title',
    defaultMessage: 'Producto no disponible',
  },
  button_product_not_available_content: {
    id:
      'app.productConfig.ProductConfiguration.button_product_not_available_content',
    defaultMessage: 'El producto o alguno de sus ingredientes está agotado.',
  },
  button_product_not_available_ok: {
    id:
      'app.productConfig.ProductConfiguration.button_product_not_available_ok',
    defaultMessage: 'Volver al menú',
  },
});
